<template>
  <div class="container">
    <h4 class="title is-4">{{chartName}}</h4>
    <app-chart-time-frames></app-chart-time-frames>
    <div id="chartdiv"></div>
  </div>
</template>

<script>
  import moment from 'moment';
  import {mapGetters, mapMutations, mapActions} from 'vuex';
  import {beautifyObjectName} from "../utils/utils";
  /* eslint-disable */
  import * as am4core from "@amcharts/amcharts4/core";
  /* eslint-disable */
  import * as am4charts from "@amcharts/amcharts4/charts";
  /* eslint-disable */
  import am4themes_dark from "@amcharts/amcharts4/themes/dark";
  import ChartTimeFrames from '../components/ChartTimeFrames';

  export default {
    name: "screen-chart-liniar",
    components: {
      appChartTimeFrames: ChartTimeFrames
    },
    data() {
      return {
        object: null,
        currentFilters: {},
        chart: null
      };
    },
    watch: {
      selectedTimeFrameId(value) {
        this.currentFilters['timeFrameId'] = parseInt(value);
        this.fetchEvents({
          ...this.currentFilters,
          cb: () => {
            this.chart.data = this.chartData;
          }
        });
      }
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('objects', ['objectById']),
      ...mapGetters('events', ['filters', 'events', 'selectedTimeFrameId']),
      chartName() {
        if (!this.object) {
          return 'Unknown Chart';
        }

        return beautifyObjectName(this.object.name);
      },
      chartData() {
        return this.events.map(item => {
          const mom = moment(item['date']);
          const date = mom.format('YYYY-MM-DD HH:mm');
          return {
            date: date,
            value: item['translatedValue']
          };
        });
      }
    },
    methods: {
      ...mapMutations('events', ['SET_FILTERS']),
      ...mapActions('events', ['fetchEvents']),
      initChart() {
        am4core.useTheme(am4themes_dark);

        this.chart = am4core.create("chartdiv", am4charts.XYChart);
        this.chart.padding(0, 15, 0, 15);
        this.chart.data = this.chartData;

        // Create axes
        let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "date";
        categoryAxis.renderer.minGridDistance = 50;
        categoryAxis.renderer.grid.template.location = 0.5;
        categoryAxis.startLocation = 0.5;
        categoryAxis.endLocation = 0.5;
        categoryAxis.renderer.labels.template.disabled = true;

        // Create value axis
        let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.baseValue = 0;

        // Create series
        let series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "date";
        series.strokeWidth = 2;
        series.tensionX = 0.77;

        // bullet is added because we add tooltip to a bullet for it to change color
        let bullet = series.bullets.push(new am4charts.Bullet());
        bullet.tooltipText = "{valueY}";

        bullet.adapter.add("fill", function (fill, target) {
          if (target.dataItem.valueY < 0) {
            return am4core.color("#FF0000");
          }
          return fill;
        });
        let range = valueAxis.createSeriesRange(series);
        range.value = 0;
        range.endValue = -1000;
        range.contents.stroke = am4core.color("#FF0000");
        range.contents.fill = range.contents.stroke;

        // Add scrollbar
        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        scrollbarX.scrollbarChart.xAxes.getIndex(0).renderer.labels.template.disabled = true;
        this.chart.scrollbarX = scrollbarX;

        this.chart.cursor = new am4charts.XYCursor();
      }
    },
    mounted() {
      const that = this;
      this.object = this.objectById(this.$route.params.objectId);
      if (this.object) {
        this.currentFilters = { ...this.filters };
        this.currentFilters['objectId'] = this.object.id;
        this.currentFilters['objectTypeId'] = this.object.object_type_id;
        this.currentFilters['orderDirection'] = 1;
        this.fetchEvents({
          ...this.currentFilters,
          cb: () => {
            that.initChart();
          }
        });
      }
    },
    destroyed() {
      am4core.disposeAllCharts();
    },
    unmounted() {
      am4core.disposeAllCharts();
    }
  }
</script>

<style scoped>
  #chartdiv {
    width: 100%;
    height: 500px;
  }

  @media all and (max-width: 480px) {
    #chartdiv {
      height: 480px;
    }
  }
</style>